import { Card, Row, Col, Button } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import { toast } from 'react-toastify';

import { WrapperOrchestrator } from '../shared/styles';
import { StatusCircle } from '../shared/StatusCircle';
import { StatusDates } from '../shared/StatusDates';
import { Clipboard } from '../shared/Clipboard';
import { OrchestratorTag } from './components/OrchestratorTag';
import { useOrchestratorList } from '../../hooks/useOrchestratorList';
import { setNid } from '../../store/slices/domainOrchestratorPricingCommittee.slice';
import { pathOPCDashboard } from '@pages/OrchestratorPricingCommitteePage/routes/routes.types';

export const OrchestratorCardsList = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { orchestrators } = useOrchestratorList();
  const { data, isFetching } = orchestrators;

  useEffect(() => {
    if (isFetching) {
      toast.loading('Cargando orquestadores...', {
        toastId: 'loading-orchestrators-list',
        position: 'bottom-right',
        closeButton: true,
      });
    } else {
      toast.dismiss('loading-orchestrators-list');
    }
  }, [isFetching]);

  const handleClick = (nid: string) => {
    dispatch(setNid(nid));
    navigate(`/orchestrator-pricing-committee/${pathOPCDashboard}`);
  };

  const filtered = data;

  return (
    <WrapperOrchestrator>
      <Row xs={1} md={2} lg={3} className="g-3">
        {filtered?.map(orchestrator => (
          <Col key={orchestrator.id} className="d-flex">
            <Card className="h-100 w-100">
              <Card.Body className="d-flex flex-column">
                <div className="d-flex flex-column justify-content-between mb-2">
                  <div className="d-flex justify-content-between align-items-center w-100">
                    <div className="d-flex gap-2 align-items-center">
                      <StatusCircle status={orchestrator.status} />
                      <span className="fw-bold">{orchestrator.nid}</span>
                      <Clipboard
                        text={orchestrator.nid}
                        toastMessage="Nid copiado"
                        dataTestId={`copy-nid-${orchestrator.id}`}
                      />
                      <OrchestratorTag
                        workflowAlias={orchestrator.workflow_alias}
                      />
                    </div>
                    <Button
                      size="sm"
                      variant="link"
                      className="p-0"
                      onClick={() => handleClick(orchestrator.nid)}
                    >
                      Ver
                    </Button>
                  </div>
                  <div className="w-100">
                    <StatusDates
                      status={orchestrator.status}
                      startAt={orchestrator.start_at}
                      endAt={orchestrator.end_at}
                      updatedAt={orchestrator.updated_at}
                    />
                  </div>
                </div>
                <ul className="mt-2 mb-0 list-unstyled">
                  {orchestrator.workflow_steps.map(step => (
                    <li
                      key={step.id}
                      className="d-flex gap-2 align-items-center"
                    >
                      <StatusCircle status={step.status} />
                      <span>{step.name}</span>
                    </li>
                  ))}
                </ul>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
    </WrapperOrchestrator>
  );
};
